import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import thunk from "redux-thunk";
import { __prod__ } from "../utils/helper";
import AdminReducer from "./reducers/admin.reducer";
import CustomerReducer from "./reducers/customer.reducer";
import PantReducer from "./reducers/pant.reducer";
import PantCategoryReducer from "./reducers/pantcategory.reducer";
import PantOptionReducer from "./reducers/pantoption.reducer";
import PantOrderReducer from "./reducers/pantOrder.reducer";
import ShirtReducer from "./reducers/shirt.reducer";
import ShirtCategoryReducer from "./reducers/shirtcategory.reducer";
import ShirtOptionReducer from "./reducers/shirtoption.reducer";
import ShirtOrderReducer from "./reducers/shirtOrder.reducer";
import MainOrderReducer from "./reducers/mainOrder.reducer";

const middleware = [thunk];

let middleWares;
if (__prod__) {
  middleWares = applyMiddleware(...middleware);
} else {
  middleWares = composeWithDevTools(applyMiddleware(...middleware));
}

const rootReducers = combineReducers({
  admin: AdminReducer,
  customer: CustomerReducer,
  pant: PantReducer,
  pantcategory: PantCategoryReducer,
  pantoption: PantOptionReducer,
  pantorder: PantOrderReducer,
  shirt: ShirtReducer,
  shirtcategory: ShirtCategoryReducer,
  shirtoption: ShirtOptionReducer,
  shirtorder: ShirtOrderReducer,
  mainorder: MainOrderReducer

});

const store = createStore(rootReducers, middleWares);

export default store;
